import { fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { setOpenLogin } from '../features/authSlice';
const API_URI = process.env.REACT_APP_API_URI;

const fBaseQuery = fetchBaseQuery({
    baseUrl: API_URI,
    prepareHeaders: (headers, { getState }) => {
        const token = window.localStorage.getItem('token');//getState().authUser.token; 
        if (token) {
            headers.set('Authorization', `Bearer ${token}`);
        }
        return headers;
    },
});

const baseQueryForm = async (args,{ signal, dispatch, getState },extraOptions) => {
  const result = await fBaseQuery(args,{ signal, dispatch, getState },extraOptions);
  if(result.error && result.error.status == 401){
    dispatch(setOpenLogin(true));
  }
  return result;
}

export default baseQueryForm;